import { ChevronDown } from 'lucide-react'

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '@/components/ui/DropdownMenu'
import { AccountTypeBadge } from '@/modules/projects/components/AccountTypeBadge'
import {
  accountTypePill,
  accountTypeWord,
} from '@/modules/projects/components/Workbench/accounts'
import {
  ACCOUNT_TYPES,
  type AccountType,
} from '@/modules/projects/components/Workbench/types'

const NO_TYPE = ''

// The app's own pill, small. It is also the picker, so choosing a type never replaces the thing that was there.
// Each choice is its pill too, so the list scans by colour.
export const TypeField = ({
  accountType,
  onPick,
}: {
  accountType: AccountType | null
  onPick: (accountType: AccountType | null) => void
}) => (
  <DropdownMenu>
    <DropdownMenuTrigger
      data-account-type-input
      title="Change what kind of account this is"
      className="group/type cursor-pointer rounded-full outline-none transition-opacity hover:opacity-80 focus-visible:ring-2 focus-visible:ring-neutral-900"
    >
      <AccountTypeBadge type={accountTypePill(accountType)} size="xs">
        {accountTypeWord(accountType)}
        <ChevronDown className="ml-0.5 size-2.5 opacity-50 transition-opacity group-hover/type:opacity-100 group-data-[state=open]/type:opacity-100" />
      </AccountTypeBadge>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="start" className="min-w-40">
      <DropdownMenuRadioGroup
        value={accountType ?? NO_TYPE}
        onValueChange={(picked) =>
          onPick(picked ? (picked as AccountType) : null)
        }
      >
        {ACCOUNT_TYPES.map((value) => (
          <DropdownMenuRadioItem
            key={value}
            value={value}
            className="cursor-pointer"
          >
            <AccountTypeBadge type={accountTypePill(value)} size="xs">
              {accountTypeWord(value)}
            </AccountTypeBadge>
          </DropdownMenuRadioItem>
        ))}
        <DropdownMenuRadioItem
          value={NO_TYPE}
          className="cursor-pointer text-ink-subtle"
        >
          {accountTypeWord(null)}
        </DropdownMenuRadioItem>
      </DropdownMenuRadioGroup>
    </DropdownMenuContent>
  </DropdownMenu>
)
